// TODO: add flow types

import React from 'react';
import PropTypes from 'prop-types';

const ListText = ({ children }) => (
  <div className="list__item__copy">{children}</div>
);

ListText.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ListText;
